//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from "vuex";
export default {
  name: "MEWS",
  data() {
    return {
      form: {
        value1: "",
        value2: "",
        value3: "",
        value4: "",
        value5: "",
      },
      hasScore: false,
      disabled: false,
      dataList: [
        { value: "3", name: "≤70" },
        { value: "2", name: "71~80或≥200" },
        { value: "1", name: "81~100" },
        { value: "0", name: "101~199" },
      ],
      dataList1: [
      { value: "0", name: "9~14" },
      { value: "1", name: "15~10" },
      { value: "2", name: "＜9或21~29" },
      { value: "3", name: "≥30" },
      ],
      dataList2: [
        { value: "0", name: "51~100" },
        { value: "1", name: "41~50或101~100" },
        { value: "2", name: "≤40或111~129" },
        { value: "3", name: "≥130" },
      ],
      dataList3: [
      { value: "0", name: "36.1~38" },
      { value: "1", name: "35.1~36或38.1~38.5" },
      { value: "2", name: "≤35或＞38.5" },
      ],
      dataList4: [
        { value: "0", name: "清醒" },
        { value: "1", name: "对声音有反应/嗜睡" },
        { value: "2", name: "对疼痛有反应" },
        { value: "3", name: "昏迷" },
      ],
 
    };
  },
  created() {
    this.hideLoad();
  },
  methods: {
    ...mapMutations(["hideLoad"]),
  },
  computed: {
    /** 计算公式结果 */
    score() {
      let self = this;
      let form = JSON.parse(JSON.stringify(self.form));
      let flag = true;
      let result = 0;
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false;
          } else {
            form[key] = Number(form[key]);
          }
        }
        result += Number(form[key]);
      }
      if (!flag) {
        self.hasScore = false;
        return "";
      } else {
        self.hasScore = true;
        return String(result);
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/pages/formulas/Common/MEWS.vue